const ITEMS = [
  "ATILMAZ SAAT",
  "ZAMANA DEĞER KATAR",
  "KOL SAATİ — GÖZLÜK — TAKI",
  "ORİJİNALLİK GARANTİSİ",
  "UZMAN TEKNİK SERVİS",
  "2006'DAN BERİ",
];

export const Marquee = () => (
  <div
    className="relative overflow-hidden bg-emerald-deep border-y border-ivory/10 py-4"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="animate-marquee-slow flex w-max items-center">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] text-ivory/45 px-8">
                {item}
              </span>
              <span className="h-1 w-1 rounded-full bg-gold/40" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
